import {
  SET_STRATEGY_DATA,
  SET_STRATEGY_ID,
  SET_STRATEGY_LIST,
  TEST_ACTION,
  TOGGLE_STRATEGY,
  START_BACKTEST_FAILED,
  START_BACKTEST_SUCCESS,
  START_BACKTEST_REQUEST,
  FILTERED_BACKTEST_DATA,
  FILTERED_EXPIRY_DATA,
  initialIsChecked,
  GROUPING_BY_EXPIRE,
  CHECKED_FILTER_DATA,
  MAX_DRAWDOWN_DATA,
  START_DATE_GRAPH_REQUEST,
  START_DATE_GRAPH_SUCCESS,
  START_DATE_GRAPH_FAILED,
  CHECKED_POSITIONAL_FILTER_DATA,
  TOKEN_EXPIRY,
  CLOSE_TOKEN_EXPIRY,
  FILTERED_BACKTEST_DATA_SUCCESS,
  FILTERED_BACKTEST_DATA_REQUEST,
  FILTERED_BACKTEST_DATA_LOADER,
} from '../constants/actionTypes';

export const initialStore = {
  expiredToken: false,
  reason:'',
  daysLoader:false,
  selectedStrategyId: 0,
  strategyData: {},
  defaultLoad: false,
  strategyList: [],
  expiries: [],
  loading: false,
  checkedfilterdata: false,
  error: false,
  backtestData: {},
  backtestResults: {},
  groupByDayExpiryResults: {},
  backtestOutputSuccess: false,
  graphDataStatus: false,
  groupByDay: false,
  backtestInputData: {},
  dateGraphData: [],
  data: [
    {
      name: 'mon',
    },
    {
      name: 'tue',
    },
    {
      name: 'wed',
    },
    {
      name: 'thu',
    },
    {
      name: 'fri',
    },
    {
      name: 'sat',
    },
  ],
  daysArray: [],
  backtestSummary: {
    average_exp_profit: 0,
    avg_day_profit: 0,
    avg_loss_loss: 0,
    avg_profit_win: 0,
    expectancy: 0,
    fri_profit: 0,
    loss_percent: 0,
    lot_size: 0,
    max_drawdown: 0,
    max_losing_streak: 0,
    max_loss: 0,
    max_profit: 0,
    max_winning_streak: 0,
    mon_profit: 0,
    overall: 0,
    return_to_mdd_ratio: 0,
    sat_profit: 0,
    thu_profit: 0,
    total_expiries: 0,
    tue_profit: 0,
    wed_profit: 0,
    win_percent: 0,
  },
};
//output.expiries.map(expiry =>
//  output.backtest_results[expiry]['results'].map(x => {
//    x.deselected = true;
//  })
//);
export default (state = initialStore, action) => {
  switch (action.type) {
    case SET_STRATEGY_ID:
      return {
        ...state,
        selectedStrategyId: action.data,
        defaultLoad: action.defaultLoad,
      };
    case SET_STRATEGY_DATA:
      return {
        ...state,
        strategyData: action.data,
      };
    case SET_STRATEGY_LIST:
      return {
        ...state,
        strategyList: action.data,
      };
    case START_BACKTEST_REQUEST:
      return {
        ...state,
        loading: true,
        backtestInputData: action.data,
        backtestOutputSuccess: false,
        // ...state,
        // backtestData: output,
        // backtestResults: output.backtest_results,
        // backtestOutputSuccess: true,
        // backtestSummary: output.summary,
        // expiries: output.expiries,
        // loading: false,
      };
    case START_BACKTEST_SUCCESS:
      return {
        ...state,
        backtestData: action.data,
        backtestResults: action.data.backtest_results,
        backtestOutputSuccess: true,
        backtestSummary: action.data.summary,
        expiries: action.data.expiries,
        loading: false,
      };
    case START_BACKTEST_FAILED:
      return {
        ...state,
        loading: false,
        error: true,
        // backtestOutputSuccess: false,
      };
    case START_DATE_GRAPH_REQUEST:
      return {
        ...state,
        loading: true,

        graphDataStatus: false,
        // ...state,
        // backtestData: output,
        // backtestResults: output.backtest_results,
        // backtestOutputSuccess: true,
        // backtestSummary: output.summary,
        // expiries: output.expiries,
        // loading: false,
      };
    case START_DATE_GRAPH_SUCCESS:
      return {
        ...state,
        dateGraphData: action.data.data,

        graphDataStatus: true,

        loading: false,
      };
    case START_DATE_GRAPH_FAILED:
      return {
        ...state,
        loading: false,
        error: true,
        // backtestOutputSuccess: false,
      };
    // case FILTERED_BACKTEST_DATA_REQUEST:
    //   return {
    //     ...state,
    //     daysLoader: true,
    //   };

    case FILTERED_BACKTEST_DATA_SUCCESS:
      return {
        ...state,
        // loading: true,
        daysArray: action.daysArray,
        backtestSummary: { ...action.backtestData, ...action.data },
        daysLoader:true,
        // groupByDayExpiryResults: action.expiryByDay,
        // backtestResults: action.obj,
      };
    case FILTERED_BACKTEST_DATA_LOADER:
      return{
        ...state,
        daysLoader:false,
      }

    case FILTERED_EXPIRY_DATA:
      return {
        ...state,
        groupByDay: true,

        groupByDayExpiryResults: action.data,
      };
    case GROUPING_BY_EXPIRE:
      return {
        ...state,
        groupByDay: false,
      };
    case CHECKED_FILTER_DATA:
      return {
        ...state,
        groupByDayExpiryResults: action.data.expiryResults,
        backtestResults: action.data.backtestsummary,
        // groupByDayExpiryResults: state.groupByDay
        //   ? action.data
        //   : state.groupByDayExpiryResults,
        // backtestResults: !state.groupByDay
        //   ? action.data
        //   : state.backtestResults,
        checkedfilterdata: !state.checkedfilterdata,
      };
    case CHECKED_POSITIONAL_FILTER_DATA:
      return {
        ...state,
        backtestResults: action.data,
      };
    case MAX_DRAWDOWN_DATA:
      return {
        ...state,
        backtestSummary: {
          ...state.backtestSummary,
          max_drawdown: action.data,
        },
      };

      case TOKEN_EXPIRY:
      return {
        ...state,
        expiredToken: true,
        reason: action.reason,
      };

    case CLOSE_TOKEN_EXPIRY:
      return {
        ...state,
        expiredToken: false,
        reason: '',
      };

    // case initialIsChecked:
    //   return {
    //     initialIsChecked: initialIsChecked(state.data),
    //   };

    default:
      return state;
  }
};
